import AnchorButton from "../AnchorButton";
import Container from "../Container";
import LinkButton from "../LinkButton";
import Logo from "../../statics/logo/logo.svg";
import { NavLink } from "react-router-dom";
import React from "react";
import useLinks from "../../hooks/useLinks";

const PublicNavbar = () => {
  const links = useLinks();

  return (
    <Container>
      <div className="relative z-10 w-full bg-white lg:flex lg:py-4">
        <div className="relative z-10 flex flex-wrap items-center justify-center w-full py-6 space-y-8 bg-white lg:space-y-0 lg:justify-between lg:py-0">
          <NavLink to="/">
            <img src={Logo} alt="Logo" width="300px" />
          </NavLink>
          <div className="flex items-center justify-end space-x-4">
            <LinkButton to="/support" theme="outline">
              Customer Support
            </LinkButton>
            <AnchorButton href={links.programBook} theme="secondary">
              Download Program Book
            </AnchorButton>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default PublicNavbar;
